import React from 'react'
import PropTypes from 'prop-types'
import 'cross-fetch'
import isEqual from 'lodash/isEqual'
import isEqualWith from 'lodash/isEqualWith'
import sortBy from 'lodash/sortBy'

import { CartItem } from '../models'

import CheckoutSection from './CheckoutSection'

const toMoneyString = (n) => n.toLocaleString('en-US', { style: 'currency', currency: 'USD' })

const mapCheckoutSummaryViewModelToSummary = function (summaryViewModel) {
  var items = [];
  if (!isNaN(summaryViewModel.SubTotal)) {
    items.push('SubTotal');
    items.push(toMoneyString(summaryViewModel.SubTotal));
  }
  if (!isNaN(summaryViewModel.ShippingTotal)) {
    items.push('ShippingTotal');
    items.push(toMoneyString(summaryViewModel.ShippingTotal));
  }
  if (!isNaN(summaryViewModel.Total)) {
    items.push('Total');
    items.push(toMoneyString(summaryViewModel.Total));
  }
  return { summary: items }
};

// @param summary: an array of strings, alternating between labels and values. 
// @returns a row of the summary for each pair of elements in the summary
const mapSummaryToRows = (summary) => {
  const last = summary.length - 2
  const { children } = summary.reduce((acc, cur) =>
    (acc.i % 2 === 0)                                                // check if cur is a multiple of 2

      ? { children: acc.children, i: acc.i + 1 }                      // if so, then skip this element
      // (it's a label we'll add on the next iteration)

      : {                                                             // if cur is an odd number, then add a row
        children: [...acc.children, (
          <tr key={acc.i} style={last > acc.i ? {} : { fontWeight: 'bold'}}>
              <td className="summary-label" style={{ width: '50%' }}>
                {summary[acc.i - 1]}:                           
              </td>
              <td className="summary-amount" style={{ textAlign: 'right', width: '50%' }}>
                {cur}
              </td>
          </tr>
        )],
          i: acc.i + 1
    }, { children: [], i: 0 }); // init reduction 
  return children;
}

const cartItemPropertiesToCompare = ['Id', 'Price', 'SKU', 'Quantity'];
function cartItemComparer(first, second) {
  cartItemPropertiesToCompare.every((propName) => first && second && (first[propName] === second[propName]));
}

class CheckoutSummary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { summary: props.summary };
  }
  
  componentWillReceiveProps(nextProps) {
    // BBS DDD 2017-12-01 This is probably not the place to do this, but I'm rushing to get done
    // Really, this should update redux state and make the data generally available.

    const placeOrderDetailsChanged = !isEqual(this.props.placeOrderDetails, nextProps.placeOrderDetails);
    const cartChanged = !isEqualWith(sortBy(this.props.cart, ['Id']), sortBy(nextProps.cart, ['Id']), cartItemComparer)
    if (placeOrderDetailsChanged || cartChanged) {
      window.fetch(nextProps.summaryEndpoint,
        {
          method: 'POST',
          headers: {},
          credentials: 'same-origin',
          body: JSON.stringify(nextProps.placeOrderDetails)
        })
        .then((response) => {
            if (response.ok) {
              return response.json();
            } else {
              this.props.onGetSummaryError(`Response was ${response.status}: '${response.statusText}'`);
            }
          }
        )
        .then((checkoutSummaryViewModel) => this.setState(mapCheckoutSummaryViewModelToSummary(checkoutSummaryViewModel)))
    }
  }

  render() {
    const summary = this.state.summary;
    const rows = mapSummaryToRows(summary);
    return (
      <CheckoutSection label='Summary' hidden={false}>
            <table style={{ width: '100%' }}>
              <tbody>
                {rows}
              </tbody>
            </table>
      </CheckoutSection>
      );
  }
}

CheckoutSummary.propTypes = {
  summary: PropTypes.arrayOf(PropTypes.string).isRequired,
  placeOrderDetails: PropTypes.object.isRequired,
  summaryEndpoint: PropTypes.string.isRequired,
  cart: PropTypes.arrayOf(CartItem.propTypes),
  onGetSummaryError: PropTypes.func.isRequired
}

export default CheckoutSummary